import { Box, Typography } from '@mui/material';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import HelpIcon from '@mui/icons-material/Help';
import BaseInput from '../BaseInput';
import { useState } from 'react';

const PrettoSlider = styled(Slider)({
  color: '#5B87EF',
  height: 4,
  padding: '0 !important',
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 16,
    width: 16,
    backgroundColor: '#fff',
    border: '4px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    display: 'none',
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

const BasePrettoSlider = ({ title, name, min, max, onChange }) => {
  const [value, setValue] = useState(min);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onChange(event, newValue)
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: { md: '8px' }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography variant="h4" color="primary.darkGray">
            {title}
          </Typography>
          <HelpIcon
            sx={{
              fontSize: '20px',
              color: 'primary.mediumGray',
              ml: '8px'
            }}
          />
        </Box>
        <Box
          sx={{
            display: { xs: 'none', md: 'block' }
          }}
        >
          <Typography variant='subText' color='primary.mainBlue'>
            Drag or fill
          </Typography>
        </Box>
        <Box
          sx={{
            minWidth: '49px',
            height: '47px',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'primary.mediumGray',
            display: { xs: 'flex', md: 'none' },
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant='body' color='primary.mainBlue'>{value}</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            width: '100%'
          }}
        >
          <PrettoSlider
            valueLabelDisplay="auto"
            aria-label="pretto slider"
            min={min}
            max={max}
            name={name}
            value={value}
            onChange={handleChange}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography variant='body' color='primary.mainBlue'>≤ {min}</Typography>
            <Typography variant='body' color='primary.mainBlue'>≥ {max}</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            maxWidth: '60px',
            height: '47px',
            display: { xs: 'none', md: 'flex' },
            justifyContent: 'center',
            alignItems: 'center',
            ml: '80px'
          }}
        >
          <BaseInput
            inputStyles={{
              color: '#5B87EF',
              padding: 0
            }}
            inputProps={{
              style: {
                textAlign: 'center'
              }
            }}
            error={min > value}
            label=''
            name={name}
            type='text'
            placeholder='Age'
            value={value}
            onChange={(e) => {
              const age = parseInt(e.target.value) || 0
              if (Number.isInteger(age) && parseInt(age) <= max) {
                handleChange(e, age)
              }
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default BasePrettoSlider